import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableV3PortionedEODManifest = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePortionedEODManifest);
};
